import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import { formatThousandsDot } from "helpers/FormatNumbersWithComma";

// Buyer (Aranan) ilan: kabul edilen maksimum km (tek üst sınır).
// Redux: newAdvert.filters.kmMax (düz sayı). Görüntüde binlik nokta ayracı.
function FLBuyerKmMax(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const value = formatThousandsDot(filters?.kmMax ?? "");

  return (
    <TextField
      type="text"
      inputMode="numeric"
      label="En Fazla Kilometre"
      variant="outlined"
      margin="dense"
      fullWidth
      value={value}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, "");
        props.editNewAdvertFilters("kmMax", digits === "" ? "" : Number(digits));
      }}
      InputProps={{ endAdornment: <InputAdornment position="end">km</InputAdornment> }}
      placeholder="Örn. 100.000"
    />
  );
}

export default connect(null, { ...advertRedux.actions })(FLBuyerKmMax);
